export const API_URL = process.env.VUE_APP_API_URL || 'https://api.eblonline.com.br/';
export const ID_URL = process.env.VUE_APP_ID_URL || 'https://id.eblonline.com.br/';
export const APP_URL = process.env.VUE_APP_APP_URL || 'https://eblonline.com.br/';
export const DOWNLOAD_BOLETO_URL = process.env.VUE_APP_DOWNLOAD_BOLETO_URL || process.env.VUE_APP_API_URL || 'https://api.eblonline.com.br/';
export const PAINEL_URL = process.env.VUE_APP_PAINEL_URL || 'https://painel.eblonline.com.br';
export const ORIGIN = process.env.VUE_APP_PAINEL_URL || 'https://painel.eblonline.com.br';
export const API_IBGE = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
